import { fork } from "@redux-saga/core/effects";
import auth from "./auth";
import layout from "./layout";
import preference from "./preference";

function* mainSaga() {
  yield fork(preference.saga);
  yield fork(layout.saga);
  yield fork(auth.saga);
}

export default mainSaga;
